/**
 * Feature flags used to hide functionality without removing it from the codebase.
 *
 * leaderboard: the International Leaderboard (the `/leaderboard` page, its entries in the navigation menus and the
 * "Players Rank in the Top 100" card on the organization dashboards). Hidden at the client's request because it
 * conflicts with the new version of the product. Event leaderboards are not affected by this flag.
 */
const features = {
    leaderboard: false,
};

export default features;
